export default __webpack_public_path__ + "static/media/unwillingsacrifice.c8c1b6ce.png";